import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import { defineAsyncComponent } from 'vue';
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    name: 'index',
    // component: IndexView,
    component: () => import('@/views/Index.vue'),
  },
  {
    path: '/game',
    name: 'game',
    component: () => import('@/views/Game/Index.vue'),
    children: [
      // {
      //   path: '',
      //   name: 'purchase',
      //   component: () => import('@/views/Game/Purchase.vue'),
      // },
      {
        path: '',
        name: 'purchase',
        component: () => import('@/views/Game/Purchase/Index.vue'),
      },
      {
        path: '/game/record',
        name: 'record',
        component: () => import('@/views/Game/Record.vue'),
      },
      {
        path: '/game/activity',
        name: 'activity',
        component: () => import('@/views/Game/Activity.vue'),
      }
    ]
  },
  {
    path: '/privacy',
    name: 'privacy',
    // component: IndexView,
    component: () => import('@/views/Privacy/Index.vue'),
  },
  {
    path: '/mobilePay',
    name: 'mobilePay',
    component: () => import('@/views/Pay/Index.vue'),
    meta: {
      noTokenLogin: true,
      hideTopNav: true,
      hideBottomMsg: true
    }
  },
    {
    path: '/payStatus',
    name: 'payStatus',
    component: () => import('@/views/Pay/Status.vue'),
    meta: {
      hideTopNav: true,
      hideBottomMsg: true
    }
  },
  {
    path: '/pay/airwallex-checkout',
    name: 'airwallexCheckout',
    component: () => import('@/views/Pay/AirwallexCheckout.vue'),
    meta: {
      hideTopNav: true,
      hideBottomMsg: true
    }
  }

]

const router = createRouter({
  history: createWebHistory(),
  // history: createWebHashHistory(),
  routes
})

export default router
